import Button from '@/atoms/Button';
import MoneyData from '@/atoms/MoneyData';
import ScanButton from '@/atoms/ScanButton';
import Spinner from '@/atoms/loader/Spinner';
import UserLink from '@/atoms/UserLink';
import MenuItemList from '@/molecules/MenuItemList';
import MetricCompact from '@/molecules/MetricCompact';
import { useModal } from 'context/Modal/Context';
import ModalNavLayout from 'context/Modal/layout/Nav';
import { MODAL_NAME } from 'context/Modal/MODAL_NAME';
import useUserNav from 'context/Modal/views/nav/user/hooks';
import useUserApi from 'hooks/UserApi/useUserApi';
import { useTranslation } from 'react-i18next';
import { isInAppWebview } from 'utils/webview';
import { WALLET_BALANCE_URL } from 'utils/cms';

type Prop = {
  closeModal: () => void;
};

const UserNavModal = ({ closeModal }: Prop) => {
  const { user } = useUserApi();
  const { menuItems, walletItem, wallet, scanItem, headerAccountFooterImage, isWalletLoading, isWalletActivated } =
    useUserNav();
  const { t } = useTranslation();
  const { openModal } = useModal();

  const openWalletEligibilityModal = () =>
    openModal(MODAL_NAME.CMS_MODAL, {
      cmsModalName: 'wallet-eligibility',
    });

  return (
    <ModalNavLayout closeModal={closeModal} direction="right">
      <div className="flex flex-col gap-4 h-full overflow-x-hidden">
        <div className="flex flex-1 flex-col gap-4 grow p-4 ">
          <div className="flex flex-row justify-between">
            <UserLink avatarPath={user?.avatarPath} nickName={user?.nickName} userUniqId={user!.uniqueId!} />
          </div>
          {walletItem && (
            <>
              {isWalletLoading && (
                <MetricCompact subLine={walletItem.label}>
                  <Spinner className="p-3" />
                </MetricCompact>
              )}
              {wallet && isWalletActivated && (
                <MetricCompact buttonProps={{ href: WALLET_BALANCE_URL }} subLine={walletItem.label}>
                  <MoneyData amount={wallet.balance} currency={wallet.currency} />
                </MetricCompact>
              )}
              {wallet && !isWalletActivated && (
                <Button onClick={openWalletEligibilityModal}>{t('unlock-wallet')}</Button>
              )}
            </>
          )}
          <MenuItemList items={menuItems} />
        </div>
        <div
          className="flex flex-1 bg-cover bg-no-repeat w-full h-96 flex-col justify-end items-stretch"
          style={{
            backgroundImage: headerAccountFooterImage,
          }}
        >
          {scanItem && isInAppWebview() && (
            <ScanButton className="mx-4 mb-4" href={scanItem.href} onClick={closeModal}>
              {t(scanItem.label)}
            </ScanButton>
          )}
        </div>
      </div>
    </ModalNavLayout>
  );
};

export default UserNavModal;
